export enum AuditReportStateEnum {
  OPEN = 'OPEN',
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
}
